import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// After client-side navigation, move focus to the main landmark so screen
// readers treat the route change like a page load. Skips the initial mount
// so document focus behaves normally on first paint.
export default function useRouteFocus(targetId = "main-content") {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const target = document.getElementById(targetId);
    if (target) {
      target.focus({ preventScroll: false });
    }
  }, [pathname, targetId]);
}
